/**
 * Use this filter to wrap a string in a template. Empty strings not wrapped.
 *
 * Usage Examples
 *
 *  Wrap string in double quotes:
 *
 *      <div>{{ str | wrap:'"' }}
 *
 *  Wrap string in brackets:
 *
 *      <div>{{ str | wrap:"(":")" }}
 */
define('common/ko/filters/wrap',['knockout', 'underscore', 'knockout.punches'], function (ko, _) {

    ko.filters.wrap = function (str, left, right) {

        return ko.computed(function () {

            var unwrapped = ko.unwrap(str);

            if (!unwrapped) {
                return '';
            }

            return left + unwrapped + (right || left);

        });
    };

});

